import { useLocation } from "react-router-dom";
import { SendFilled } from "components/OldDesign/Icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AddPeopleButton = () => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <Link className="" to="/invite" state={{ previousLocation: location }}>
      <button className="flex w-[135px] items-center justify-center gap-1 rounded-xl bg-[radial-gradient(143.14%_158.2%_at_104.39%_0%,#88A9FD_0%,#1F0877_100%)] p-3 text-neutral-100 max-lg:px-1.5 max-lg:text-[13px]">
        <SendFilled className="h-4 w-4 max-lg:h-3 max-lg:w-3" />
        <span className="font-medium leading-tight">{t("button.add_people")}</span>
      </button>
    </Link>
  );
};

export default AddPeopleButton;
